import BigNumber from "bignumber.js";

const PERCENT_100 = new BigNumber("100");
export const AMOUNT_GROUPS_DECIMALS_LENGTH = 2;

export const ZERO_BIG_NUMBER = new BigNumber(0);

export function getRoundedBigNumber(amount: BigNumber): string {
    return amount.toFixed(AMOUNT_GROUPS_DECIMALS_LENGTH, BigNumber.ROUND_DOWN);
}

export function getRoundedNumber(num: number): string {
    return new BigNumber(num).toFixed(AMOUNT_GROUPS_DECIMALS_LENGTH, BigNumber.ROUND_DOWN);
}

export function getRoundedNumberWithoutTrailingZeros(num: number): string {
    const bigNum = new BigNumber(num);
    const rounded = bigNum.toFixed(AMOUNT_GROUPS_DECIMALS_LENGTH, BigNumber.ROUND_DOWN);
    // Remover ceros innecesarios al final
    return rounded.replace(/\.?0+$/, '');
}

export function getRoundedNumberFromCents(cents: number): string {
    const bigNum = new BigNumber(cents).dividedBy(100);
    const rounded = bigNum.toFixed(AMOUNT_GROUPS_DECIMALS_LENGTH, BigNumber.ROUND_DOWN);
    // Remover ceros innecesarios al final
    return rounded.replace(/\.?0+$/, '');
}

export function getPercentOfAmountBigNumber(amount: BigNumber, percent: BigNumber): BigNumber {
    return percent.multipliedBy(amount).dividedBy(PERCENT_100);
}

export function plusPercentToAmountBigNumber(amount: BigNumber, percent: BigNumber): BigNumber {
    const percentAmount = getPercentOfAmountBigNumber(amount, percent);
    return amount.plus(percentAmount);
}

export function sumPercentsBigNumber(percents: string[] | number[]): BigNumber {
    return percents.map(p => new BigNumber(p)).reduce((sum, item) => sum.plus(item), new BigNumber(0));
}

export function sumBigNumbers(numbers: Array<string | number | BigNumber>): BigNumber {
    return numbers.reduce<BigNumber>((sum, num) => {
        const bigNum = num instanceof BigNumber ? num : new BigNumber(num);
        return sum.plus(bigNum);
    }, new BigNumber(0));
}